import { render, staticRenderFns } from "./RtkAnalysis.vue?vue&type=template&id=3bf81a07&scoped=true"
import script from "./RtkAnalysis.vue?vue&type=script&lang=js"
export * from "./RtkAnalysis.vue?vue&type=script&lang=js"
import style0 from "./RtkAnalysis.vue?vue&type=style&index=0&id=3bf81a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf81a07",
  null
  
)

export default component.exports